/**
 * Module definition for all common implementations.
 *
 * @module stack.common
 */
angular.module('stack.common.api.validation', [
  'stack.common.api.validation.ValidationService'
]);
